function bundleDraw() {
    let height = document.querySelector('.headernav').getBoundingClientRect().height;
    document.querySelector('main').style['padding-top'] = `${height}px`;

    let step_header = window.localStorage.getItem('step_header');
    let step_header_style = window.localStorage.getItem('step_header_style');

    // window.items = JSON.parse(window.localStorage.getItem('bundleandsave'));

    document.querySelector('#custom-process').innerHTML = step_header_style;
    document.querySelector('#custom-process').innerHTML += step_header;
    
    document.querySelector('.step-process.current').classList.add('active');
    document.querySelector('.step-process.current').classList.remove('current');

    const meta_products = JSON.parse(window.localStorage.getItem('m_products'));

    const container = document.querySelector('.bundle-product-container');

    for(const product of meta_products) {
      let handle = product.handle;

      let url = `${window.Shopify.routes.root}products/${handle}?sections=bundle-product-section`;

      const productEl = document.createElement('div');
      productEl.setAttribute('id', product.title);

      container.appendChild(productEl);

      fetch(url)
      .then(res => res.json())
      .then(res => {
        console.log(res);
        let content = new DOMParser().parseFromString(res['bundle-product-section'], 'text/html').querySelector('product-block').outerHTML;

        productEl.innerHTML = content;
      });
    }
}

bundleDraw();

class DropDown extends HTMLElement {
    constructor() {
        super();
        this.options = this.querySelectorAll('.drop-option');
        const current = this.querySelector('.current-select');

        current.addEventListener('click', () => {
            this.classList.toggle('open');
        });
        this.options.forEach( option => {
            option.addEventListener('click', () => {
                current.querySelector('span').innerHTML = option.innerHTML;
                console.log(this);
                this.classList.toggle('open', false);
            });
        });
    }
}

customElements.define('drop-down', DropDown);

class ProductBlock extends HTMLElement {
    constructor() {
        super();

        this.swiper = new Swiper( this.querySelector('.mySwiper'), {
            spaceBetween: 10,
            slidesPerView: 4,
            navigation: {
              nextEl: this.querySelector(".swiper-button-next"),
              prevEl: this.querySelector(".swiper-button-prev"),
            },
            breakpoints: {
              1536: {
                spaceBetween: 26,
              },
            },
        });

        this.swiper2 = new Swiper(this.querySelector('.mySwiper2'), {
            spaceBetween: 10,
            loop: true,
            zoom: {
              maxRatio: 1.5,
              minRatio: 1,
            },
            navigation: {
                nextEl: this.querySelector(".swiper-button-next.swiper-2-next"),
                prevEl: this.querySelector(".swiper-button-prev.swiper-2-prev"),
            },
            pagination: {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
                dynamicBullets: true,
            },
            thumbs: {
              swiper: this.swiper,
            }
        });
        
        this.product = JSON.parse(this.querySelector('.product-json').textContent);
        
        let v_id = this.dataset['v_id'];
        
        for (const variant of this.product.variants) {
            if(variant.id == v_id) {
                this.cur_variant = variant;
                this.cur_options = variant.options.join();
                this.cur_variant.options.forEach( option => {
                    this.querySelectorAll('option-item').forEach( item => {
                    let value = item.dataset['value'];
                    value == option ? item.classList.toggle('selected', true) : null;
                    })
                })
                this.dataset['v_id'] = this.cur_variant.id;
                break;
            }
        }

        this.atcEl = this.querySelector('.add-to-selection');
        this.curpriceEl = this.querySelector('.compare_price');
        this.cur_symbol = document.querySelector('#currency_symbol').textContent;
        if(this.querySelector('.discount-badge')) {
            this.dispriceEl = this.querySelector('.discounted_price');
            this.savepriceEl = this.querySelector('.saved_price');
            this.discount = this.querySelector('.discount-badge')?.dataset?.discount; 
        } else {
            this.discount = 100;
        }
        this.addActions();
    }

    addActions() {
        window.mySwiper = this.swiper2;
        this.swiper2.on("slideChangeTransitionStart", this.swiper2.zoom.out);
            
        this.swiper2.on('slideChange', function (e) {
            var index_currentSlide = this.activeIndex;
            index_currentSlide = parseInt(index_currentSlide);
            if(index_currentSlide > 3){
                this.querySelector('.swiper-button-prev.swiper-2-prev').classList.remove('hidden')
            }
        });

        if( window.innerWidth >= 768) {
            this.swiper2.on('click', this.swiper2.zoom.in);
        }

        this.addEventListener('selectopt', this.updateVariant.bind(this));
        this.atcEl.addEventListener('click', this.addToSelection.bind(this));
    }

    updateVariant(ev) {
        let cur_options = this.cur_options.split(',');
        let v_option = ev.target.dataset['v_option'];
        let value = ev.target.dataset['value'];
        let parent = this;
        this.product.options.forEach( (option, arg) => {
            if(option == v_option) {
                cur_options[arg] = value;
                    console.log(option);
                    parent.querySelector(`h2.selected[data-option="${option}"]`).innerHTML = value;                
            }
        });

        this.product.variants.forEach(variant => {
            for (let i = 0; i < cur_options.length; i++) {
                if(variant.options[i] == cur_options[i]) {
                if(i == cur_options.length - 1) {
                    this.cur_variant = variant;
                    this.cur_options = cur_options.join();
                }
                } else {
                break;
                }
            }
        });
 
        this.dataset['v_id'] = this.cur_variant.id;
        this.curpriceEl.innerHTML = `<span class='money'>${this.cur_symbol}${(this.cur_variant.price / 100).toFixed(2)}</span>`
        this.discount < 100 ? this.dispriceEl.innerHTML = `<span class='money'>${this.cur_symbol}${(this.cur_variant.price * this.discount / 100 / 100 ).toFixed(2)}</span>` : null;
        this.discount < 100 ? this.savepriceEl.innerHTML = `SAVE&nbsp;<span class='money'>${this.cur_symbol}${(this.cur_variant.price * (100 - this.discount) / 100 / 100 ).toFixed(2)}</span>` : null;


        if(this.cur_variant.featured_media) {

            let v_img = this.cur_variant.featured_media.id;
            let slidedImage = false;
        
            this.querySelectorAll('.mySwiper2 .swiper-slide img').forEach( (img, arg) => {
                if(img.dataset['id'] == v_img && slidedImage != true) {
                    slidedImage = true;
                    this.swiper2.slideTo(arg);
                }
            });
        }
        console.log(this.cur_variant);
    }

    addToSelection() {
        let v_id = this.dataset['v_id'];

        window.items = [{
            id: v_id,
            quantity: 1,
            properties: {
                '__step-bundle': true
            }
        }];
        console.log(window.items);

        const items = window.items;
        const sections = 'cart-drawer';

        fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(res => {
            let hasStepBundle = false;
            for (let index = 0; index < res.items.length; index++) {
                const item = res.items[index];
                if (!hasStepBundle && item.properties['__step-bundle'] && item.id == v_id) {
                    hasStepBundle = true;
                }
            }
            if (!hasStepBundle) {
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items,
                        sections
                    })
                })
                .then(res => res.json())
                .then(res => {
                    
                    updateCartIndicators(false, true);
                    console.log(res);
                })
                .catch(err => console.log(err));
            } else {
                cartDrawer = document.getElementsByClassName('slider_cart_holder')[0];
                if (!cartDrawer.classList.contains('active')) {
                  cartDrawer.classList.add("active");
                }
            }
        })
    }

}

customElements.define('product-block', ProductBlock);

function updateCartIndicators(cartIcon, addToCart, callback) {
    handleButtonLoadingState(true);
    $.get({
      url: "/cart.js",
      dataType: 'json',
      success: function(data) {
        if (addToCart) {
          cartDrawer = document.getElementsByClassName('slider_cart_holder')[0];
          if (!cartDrawer.classList.contains('active')) {
            cartDrawer.classList.add("active");
          }
        }
  
        let freeGifting_thredhold = "120"
        if(freeGifting_thredhold * 100 > data.total_price) {
          const free_gift = data.items.find((item) => item.properties.__bundleDiscount_100 == "true");
          if (free_gift) {
            $.post({
              url: "/cart/change.js",
              dataType: 'json',
              data: {
                id: free_gift.id,
                quantity: 0
              },
              success: function() {
                updateCartIndicators(true, false);
              }
            });
          }
        }
  
  
        if (cartIcon) { // Update cart in the top right
          var cartNumber = data.item_count,
            cartNumberEl = document.getElementsByClassName('site-header__cart-count')[0],
            cartNumberSpan = cartNumberEl.getElementsByTagName('span')[0];
  
          if (data.items.length) {
            cartNumberEl.classList.remove('hide');
            cartNumberSpan.innerHTML = cartNumber;
          } else {
            cartNumberEl.classList.add('hide');
            cartNumberSpan.innerHTML = 0;
          }
        }
  
        reBuildCart();
      }
    });
}